export { toBooleanFromBit } from '../../product/utils/productHelpers';

export const CONTENT_TYPE_OPTIONS = [
  { value: 'html_block', label: 'HTML block' },
  { value: 'vendor_block', label: 'Vendor block' },
  { value: 'review_block', label: 'Review block' },
];

export const PLACEMENT_OPTIONS = [
  { value: 'tab', label: 'Tab' },
  { value: 'sidebar', label: 'Sidebar' },
];

export const DEFAULT_CONTENT_CONFIG_BY_TYPE = {
  html_block: {},
  vendor_block: {},
  review_block: {},
};

export const getDefaultContentConfig = (contentType) =>
  DEFAULT_CONTENT_CONFIG_BY_TYPE[contentType] || {};

export const getDefaultPlacementForType = () => 'tab';

export const formatContentConfigForView = (config) => {
  if (!config || typeof config !== 'object') return '-';
  const keys = Object.keys(config);
  if (keys.length === 0) return '{}';
  try {
    return JSON.stringify(config);
  } catch {
    return '-';
  }
};
